//转换左侧菜单数据结构
export function menuDataConvert(treeList, parentNode, isAjaxData = true) {
  for (let item of treeList) {
    // 后台结构体转义
    if (isAjaxData) {
      item.tip = item.title
      item.title = item.name
      item.name = item.component
    }
    if (!item.id) item.id = item.title + '-' + item.name
    if (parentNode) {
      item.parentName = []
      if (parentNode.parentName) {
        item.parentName.push(...parentNode.parentName)
      }
      item.parentName.push(parentNode.id)
      // console.info('item.parentName', item.parentName);
    }
    if (item.children) {
      menuDataConvert(item.children, item, isAjaxData)
    }
  }
  return treeList
}

//设置树状结构的层级
export function setDepth(treeList, index = 1) {
  for (let item of treeList) {
    item.depth = index
    if (item.children) {
      setDepth(item.children, index + 1)
    }
  }
  return treeList
}

//根据name查找路由，也支持传入key
export function getRouteByName(treeList, name, key = 'name') {
  if (!treeList?.length || !name) return null
  for (let list of treeList) {
    const route = list[key] === name ? list : getRouteByName(list.children, name, key)
    if (route) return route
  }
  return null
}
